<template>
  <v-card
    class="mx-auto rounded-card card-shadow"
    v-bind="$attrs"
  >
    <v-card-text class="text--primary">
      <figure>
        <v-chart :options="chart"
                 :class="chatClass"
                 ref="quantidadeCotacoesChart"
                 theme="secondary"
                 autoresize/>
      </figure>
    </v-card-text>
  </v-card>
</template>

<script>
import { SituacaoCompra } from 'px-business-components';
import chartMixin from '@/mixins/chart-mixin';
import { buildCategoryEnumChart, toEchartData } from '@/utils/chart-utils';
import IndicadoresService from './dashboard-service';

const COLOR_MAP = {
  APROVADA: '#43A047',
  RECUSADA: '#F4511E',
  CANCELADA: '#F4511E',
  ELABORACAO: '#FFB300',
};

export default {
  props: {
    stringFilter: String,
    chatClass: {
      type: String,
      default: 'quantidade-chart-small',
    },
  },
  data() {
    return {
      indicadoresCompras: null,
      chart: null,
    };
  },
  mixins: [chartMixin],
  watch: {
    stringFilter(newValue, oldValue) {
      if (newValue === oldValue) {
        return;
      }
      this.getIndicadoresCompras();
    },
  },
  methods: {
    showLoading() {
      this.$refs.quantidadeCotacoesChart.showLoading(this.loadingConfig);
    },
    hideLoading() {
      if (!this.$refs.quantidadeCotacoesChart) {
        return;
      }
      this.$refs.quantidadeCotacoesChart.hideLoading();
    },
    buildChart() {
      const chartData = buildCategoryEnumChart(this.indicadoresCompras, SituacaoCompra.keys);
      return {
        title: {
          text: 'Quantidade de compras por situação',
        },
        tooltip: {
          trigger: 'axis',
          formatter: this.tooltipTextFormatterAxis,
        },
        dataset: {
          source: [
            ['Quantidade'],
            ...toEchartData(chartData, 'description', 'value'),
          ],
        },
        xAxis: {
          type: 'value',
        },
        yAxis: {
          type: 'category',
          interval: 1,
          maxInterval: 1,
          splitNumber: 1,
          axisLabel: {
            rotate: -45,
            formatter: this.axisFormatterTruncate(5),
          },
        },
        grid: {
          left: '15%',
        },
        series: [
          {
            realtimeSort: true,
            seriesLayoutBy: 'column',
            type: 'bar',
            barMaxWidth: 16,
            itemStyle: {
              color(param) {
                const { data } = param;
                return COLOR_MAP[data[2]] || '#0277BD';
              },
            },
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)',
              },
            },
          },
        ],
      };
    },
    getIndicadoresCompras() {
      this.showLoading();

      IndicadoresService.getIndicadoresCompras({
        filter: this.stringFilter,
      })
        .then((response) => {
          this.indicadoresCompras = response.data;
          this.chart = this.buildChart();
        })
        .finally(() => {
          this.hideLoading();
        });
    },
  },
  mounted() {
    this.getIndicadoresCompras();
  },
};
</script>
